module.exports = {"news":{"title":"{service}, yksi useista projekteista"}};